import { Autocomplete, Avatar, Box, Button, CircularProgress, Container, createTheme, CssBaseline, Dialog, DialogContent, DialogTitle, Divider, Grid, Paper, TextField, ThemeProvider, Typography } from '@mui/material';
import SendIcon from "@mui/icons-material/Send";
import React, { useEffect } from 'react';
import { renderToString } from 'react-dom/server';
import { Sexo } from '../modules/ui/Sexo';
import { useState } from 'react';
import { SelectCustom } from '../modules/ui/SelectCustom';
import Swal from 'sweetalert2';
import { CountryRegionData } from "react-country-region-selector";

import moment from 'moment';
import { saveData } from '../../services/saveData';
import { sendEmail } from '../../services/sendEmail';
import { uploadFile } from '../../services/uploadFile';
import { setEmailBodySemanaDePosgrado } from '../../helpers/setEmailBodySemanaDePosgrado';
import validator from 'validator';


export const SemanaDePosgrado = () => {

    // Dato necesario para subir los archivos
    const PROY = 'SEMPG';

    const [formValues, setFormValues] = useState({
        estApellidoPaterno: "",
        estApellidoMaterno: "",
        estNombres: "",
        estFechaNac: "",
        estSexo: "",
        estPais: "",
        estEstado: "",
        estNacionalidad: "",
        estCorreo: "",
        partInstProcedencia: "",
        partPrograma: "",
        partYear: "",
        partModalidad: "",
        partArteCient: "",
        partPronaces: "",

        resTitulo: "",
        resDirector: "",
        
        fechaRegistro: moment().format('YYYY-MM-DDTHH:mm:ss'),
    });
    const {
        estApellidoPaterno,
        estApellidoMaterno,
        estNombres,
        estFechaNac,
        estSexo,
        estPais,
        estEstado,
        estNacionalidad,
        estCorreo,
        partInstProcedencia,
        partPrograma,
        partYear,
        partModalidad,
        partArteCient,
        partPronaces,

        resTitulo,
        resDirector,
        
        fechaRegistro,
    } = formValues;

    // state para el fileupload
    const [file, setFile] = useState({
        file: '',
    });
    const setFileState = (e) => {    
        setFile({ file: e.target.files[0] });    
    };
    
    // Par de controles "Select" relacionados
    const [insts] = useState([ "", "CIBNOR", "CICIMAR", "ITLP", "UABCS" ]);
    const [progs, setProgs] = useState([]);

    const [paisNac, setPaisNac] = useState([]);
    const [edoNac, setEdoNac] = useState([]);
    const [countries, setCountries] = useState([]);
    
    // Para mostrar un dialogo que bloquea el registro
    const [isRegisterTime, setIsRegisterTime] = useState(false);

    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);
    const handleCloseWaitingDialog = (_, reason) => {
        console.log(reason);
        if (reason !== 'backdropClick') {
        }
    };

    const getProgs = (inst) => {

        // Version 2023

        setProgs( [
            "", 
            "MAESTRÍA", 
            "DOCTORADO",
            "ESPECIALIDAD", 
        ] );

        // switch (inst) {
        //     case "CIBNOR":
        //         setProgs( [
        //             "", 
        //             "MAESTRÍA EN CIENCIAS EN USO, MANEJO Y PRESERVACIÓN DE LOS RECURSOS NATURALES", 
        //             "DOCTORADO EN CIENCIAS EN BIOECONOMÍA PESQUERA Y ACUÍCOLA",
        //             "DOCTORADO EN CIENCIAS EN EL USO, MANEJO Y PRESERVACIÓN DE LOS RECURSOS NATURALES"
        //         ] );
        //         break;
        //     case "CICIMAR":
        //         setProgs( [
        //             "", 
        //             "MAESTRÍA EN CIENCIAS EN MANEJO DE RECURSOS MARINOS", 
        //             "DOCTORADO EN CIENCIAS MARINAS",
        //             "DOCTORADO EN CIENCIAS EN BIOECONOMÍA PESQUERA Y ACUÍCOLA",
        //             "ESPECIALIDAD EN GESTIÓN DE AMBIENTES COSTEROS"
        //         ] );
        //         break;
        //     case "ITLP":
        //         setProgs( [
        //             "", 
        //             "MAESTRÍA EN SISTEMAS COMPUTACIONALES", 
        //             "MAESTRÍA EN PLANIFICACIÓN DE EMPRESAS Y DESARROLLO REGIONAL"
        //         ] );
        //         break;
        //     case "UABCS":
        //         setProgs( [
        //             "", 
        //             "MAESTRÍA EN CIENCIAS DE INNOVACIÓN EN PRODUCCIÓN ORGÁNICA EN AMBIENTES ÁRIDOS Y COSTEROS (CIPO)", 
        //             "MAESTRÍA EN CIENCIAS MARINAS Y COSTERAS (CIMACO)",
        //             "MAESTRÍA EN DESARROLLO SUSTENTABLE Y GLOBALIZACIÓN (DESyGLO)",
        //             "MAESTRÍA EN ADMINISTRACIÓN ESTRATÉGICA (MAE)",
        //             "MAESTRÍA EN INVESTIGACIÓN HISTÓRICO – LITERARIA (MIHL)",
        //             "MAESTRÍA EN TECNOLOGÍAS DE LA INFORMACIÓN (MATI)",
        //             "MAESTRÍA INTERINSTUCIONAL EN DERECHOS HUMANOS (MIDH)",
        //             "DOCTORADO EN CIENCIAS MARINAS Y COSTERAS (CIMACO)",
        //             "DOCTORADO INTERINSTUCIONAL GESTIÓN Y NEGOCIOS (DIGN)",
        //             "DOCTORADO EN DESARROLLO SUSTENTABLE Y GLOBALIZACIÓN (DESyGLO)",
        //             "DOCTORADO INTERINSTITUCIONAL EN DERECHOS HUMANOS",
        //         ] );
        //         break;
        //     case "OTRA":
        //         setProgs( [
        //             "", 
        //             "OTRO PROGRAMA DE MAESTRÍA", 
        //             "OTRO PROGRAMA DE DOCTORADO"
        //         ] );
        //         break;
        //     default:
        //         setProgs([]);
        //         break;
        // }

        setFormValues({
            ...formValues,
            partInstProcedencia: inst,
        });
    };
    const handleProgs = (prog) => {
        setFormValues({
            ...formValues,
            partPrograma: prog,
        });
    }

    const getEstados = (pais) => {
//        console.log(pais);
        // const estados = (pais !== null) ? countries.find( (item) => item.name === pais ).regions : '';
        if (pais !== null) {
            setEdoNac( countries.find( (item) => item.name === pais ).regions );
        } else {
            setEdoNac([]);
        }
        setFormValues({
            ...formValues,
            estPais: pais,
        });
//        console.log("estados", estados);
    }
    const handleEdos = (edo) => {
        setFormValues({
            ...formValues,
            estEstado: edo,
        });
    }

    // Cada que cambia el valor en cualquier control de formulario, 
    const handleInputChange = ({ target }) => {
        // console.log(target.name, target.value);
        setFormValues({
            ...formValues,
            [target.name]: target.value,
        });
    };

    const isFormValid = () => {

        // Campos obligatorios para todos
        if ( [ estApellidoPaterno, estNombres, estFechaNac, estSexo, estPais, estEstado, estNacionalidad, estCorreo, partInstProcedencia, partPrograma, partYear, partModalidad, resTitulo, resDirector ].includes("") ) {
            Swal.fire("Elementos vacios.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        // El correo es invalido
        if ( !validator.isEmail(estCorreo) ) {
            Swal.fire("Correo electrónico incorrecto.", "El formato del correo electrónico no es valido.", "error");
            return false;
        }

        // No ha indicado ningun archivo
        if ( file.file === '' ) {
            Swal.fire("Agregar documento.", `Por favor anexa un archivo ZIP.`, "error");
            return false;
        }
        
        // Indico archivo pero no es un ZIP
        const fullName = file.file.name;
        const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
        if ( file.file !== '' && fileExt !== 'ZIP' ) {
            Swal.fire("Archivo incorrecto.", `Debe ser un archivo ZIP.`, "error");
            return false;
        }

        return true;
    }

    const onError = () => {
        sendEmail({
            "toemail": "eventos@cibnor.mx",
            "subject": "[Expociencias 2022] Error",
            "message": formValues,
        });

        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            title: "Sucedío un error en el servidor...",
            text: 'Disculpe el inconveniente.',
            icon: 'error',
            confirmButtonText: 'Ok',
            footer: 'Ya se ha notificado al area correspondiente sobre su situación.'
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.replace('https://www.cibnor.gob.mx');
            }
        }); 
    }

    const isDataProcessed = async() => {
        // Muestra al usuario el waiting dialog
        setSendingForm(true);
        console.log('Data send...');

        // Guardar en DB (devuelve el id que recibe)
        const saveResult = await saveData({formValues:formValues, apiName:'SemanaDePosgrado'});
        console.table(saveResult);
        if (saveResult.exito === 0) {
            onError();
            return false;
        }

        // - subir archivo
        const fileName = `${PROY}${saveResult.data}_archivo.zip`
        const resultUpload = await uploadFile({file, fileName});
        console.log(resultUpload);
        if (resultUpload.exito === 0) {
            onError();
            return false;
        }

        // - enviar correo
        const urlArchivo = `https://eventos.cibnor.mx/registro/apiServiciosSIARF/${resultUpload.data}`;
        const msgbody = renderToString( setEmailBodySemanaDePosgrado(formValues, urlArchivo) );
        const emailResult = await sendEmail({
            "toemail": estCorreo,
            "subject": "[Semana de Posgrado] Registro en línea",
            "message": msgbody,
            "replyto": "semanadeposgrado@cibnor.mx",
            "tocc": process.env.REACT_APP_TOCC_SEMANADEPOSGRADO,
        });
        console.log(emailResult);
        if (emailResult.exito === 0) {
            onError();
            return false;
        }

        // Oculta el waiting dialog
        setSendingForm(false);

        // Notificamos al usuario
        Swal.fire({
            title: "Sus datos han sido recibidos exitosamente.",
            text: 'Consulte su correo electrónico para más información.',
            icon: 'success',
            confirmButtonText: 'Ver mas eventos',
            allowEscapeKey: false,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
            }
        }); 

        return true;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        // if (isRegisterTime) {
        //     Swal.fire("El periodo de registro ya concluyó.");
        //     return false;
        // }
        
        // No paso la validacion, deten el procesamiento
        if ( !isFormValid() ) {
            return false;
        }

        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                isDataProcessed();
            }
        })
        
        console.log( "formValues", 
            "[",
            estApellidoPaterno,
        estApellidoMaterno,
        estNombres,
        estFechaNac,
        estSexo,
        estPais,
        estEstado,
        estNacionalidad,
        estCorreo,
        partInstProcedencia,
        partPrograma,
        partYear,
        partModalidad,
        partArteCient,
        partPronaces,

        resTitulo,
        resDirector,
        
        fechaRegistro,
            "]"
        );
    }

    useEffect(() => {
        // Is register time?
        const isRT = () => {
            const today = moment();
            // Ultimo dia de registro
            const regEnd = moment("03-31-2023", "MM-DD-YYYY");
    
            
            // const difStart = today.diff(regStart, 'hours');
            const difEnd = today.diff(regEnd, 'hours');
            // console.log(difEnd);
            ( difEnd <= 6 ) ? setIsRegisterTime(false) : setIsRegisterTime(true) ;
        }
        isRT();

        const setCountriesAndRegions = () => {
            let countries = [];
            let paises = [];
            let regions = [];
            CountryRegionData.forEach( (item) => {
                // Limpiamos el arreglo
                regions = [];
                // Agregamos a «paises» unicamente los nombres de los paises
                paises.push(item[0]);
                // Agregamos a «regions» de cada elemento lo recuperado 
                // desde el inicio hasta una posicion antes del "~"
                item[2].split("|").forEach( (reg) => {
                    regions.push( reg.slice(0, reg.indexOf("~")) )
                })
                // Agregamos a «countries» el nombre del pais y las regiones recuperadas
                countries.push({name:item[0], regions:regions});
            } )
            // Establecemos los diferentes elementos con la info procesada 
            setCountries(countries);
            setPaisNac(paises);
        }
        setCountriesAndRegions();

    }, [  ]);


    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Box sx={{ mt: 4, mb: 8, display: "flex", flexDirection: "column", alignItems: "center" }} >
                <Avatar
                    sx={{ width: '100%', height: '100%' }}
                    src="https://eventos.cibnor.mx/registro/en-linea/_logos/logo-xxii-semana-posgrado.png"
                    variant="square" 
                />
                {/* <Typography variant="h2" sx={{ mt: 3 }}>Semana de posgrado</Typography> */}
                <Typography variant="h5" sx={{ mt: 3 }}>Registro en línea</Typography>

                {/* Inicio del formulario */}
                <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 2 }}
                    autoComplete="off"
                >
                    {/* Estudiante */}
                    <Paper elevation={2}>
                    <Grid container spacing={2} sx={{ pb: 4, pl: 2, pr: 2, mt: 2, mb: 3 }} >
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" sx={{ pt: 0, fontWeight: 900 }} >Datos generales</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="estApellidoPaterno"
                                label={`Apellido paterno`}
                                name="estApellidoPaterno"
                                required
                                size="small"
                                value={estApellidoPaterno}
                                onChange={handleInputChange}
                                variant='standard'
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="estApellidoMaterno"
                                label={`Apellido materno`}
                                name="estApellidoMaterno"
                                size="small"
                                value={estApellidoMaterno}
                                onChange={handleInputChange}
                                variant='standard'
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                fullWidth
                                id="estNombres"
                                label={`Nombre(s)`}
                                name="estNombres"
                                required
                                size="small"
                                value={estNombres}
                                onChange={handleInputChange}
                                variant='standard'
                            />
                        </Grid>
                        <Grid item xs={4} >
                            <Sexo
                                parentCallback={handleInputChange}
                                name={"estSexo"}
                                label={"Sexo"}
                                required
                                variant='standard'
                            />
                        </Grid>

                        <Grid item xs={6} sx={{ mt: 1 }} >
                            <TextField
                                fullWidth
                                helperText="Fecha de nacimiento *"
                                id="estFechaNac"
                                name="estFechaNac"
                                onChange={handleInputChange}
                                required
                                size="small"
                                type={"date"}
                                value={estFechaNac}
                                variant='standard'
                            />
                        </Grid>

                        <Grid item xs={12} sx={{ mt: -1 }}>
                            <Autocomplete
                                onChange={(_, pais) => getEstados(pais)}
                                options={paisNac}
                                renderInput={(params) => (
                                    <TextField {...params} label="País de nacimiento *" variant="standard" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                disabled={!edoNac.length}
                                key={edoNac}
                                onChange={(_, edo) => handleEdos(edo)}
                                options={edoNac}
                                renderInput={(params) => (
                                    <TextField {...params} label="Estado de nacimiento *" variant="standard" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                id="estNacionalidad"
                                label="Nacionalidad"
                                name="estNacionalidad"
                                required
                                size="small"
                                value={estNacionalidad}
                                onChange={handleInputChange}
                                variant='standard'
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="estCorreo"
                                label="Correo electrónico"
                                name="estCorreo"
                                required
                                size="small"
                                value={estCorreo}
                                onChange={handleInputChange}
                                variant='standard'
                            />
                        </Grid>
                        {/* Participacion */}
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" sx={{ pt: 4, fontWeight: 900 }} >
                                Participación
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                onChange={(_, inst) => getProgs(inst)}
                                options={insts}
                                renderInput={(params) => (
                                    <TextField {...params} label="Institución *" variant="standard" />
                                )}
                                name="partInstProcedencia"
                                value={partInstProcedencia}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                disabled={!progs.length}
                                key={progs}
                                onChange={(_, prog) => handleProgs(prog)}
                                options={progs}
                                renderInput={(params) => (
                                    <TextField {...params} label="Programa de posgrado *" variant="standard" />
                                )}
                                name="partPrograma"
                                value={partPrograma}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <SelectCustom
                                parentCallback={handleInputChange}
                                name={"partYear"}
                                label={"Año de estudios en el que se encuentra"}
                                variant={"standard"}
                                options={[
                                    {value:'1', label:'1'},
                                    {value:'2', label:'2'},
                                    {value:'3', label:'3'},
                                    {value:'4', label:'4'},
                                    {value:'5', label:'5'},
                                ]}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <SelectCustom
                                parentCallback={handleInputChange}
                                name={"partModalidad"}
                                label={"Tipo de modalidad"}
                                variant={"standard"}
                                options={[
                                    {value:'Ponencia', label:'Ponencia'},
                                    {value:'Poster', label:'Poster'},
                                    {value:'Podcast/Video', label:'Podcast/Video'},
                                ]}
                                required
                            />
                        </Grid>
                        {/* <Grid item xs={12} >
                            <SelectCustom
                                parentCallback={handleInputChange}
                                name={"partArteCient"}
                                label={"Además, participarás en la modalidad de arte científico"}
                                variant={"standard"}
                                options={[
                                    {value:'Si', label:'Si'},
                                    {value:'No', label:'No'},
                                ]}
                            />
                        </Grid> */}
                        <Grid item xs={12} >
                            <SelectCustom
                                parentCallback={handleInputChange}
                                name={"partPronaces"}
                                label={"En qué PRONACES se inserta tu trabajo"}
                                variant={"standard"}
                                options={[
                                    {value:'Agentes tóxicos y procesos contaminantes', label:'Agentes tóxicos y procesos contaminantes'},
                                    {value:'Agua', label:'Agua'},
                                    {value:'Cultura', label:'Cultura'},
                                    {value:'Educación', label:'Educación'},
                                    {value:'Energía y cambio climático', label:'Energía y cambio climático'},
                                    {value:'Salud', label:'Salud'},
                                    {value:'Seguridad humana', label:'Seguridad humana'},
                                    {value:'Sistemas socio-ecológicos', label:'Sistemas socio-ecológicos'},
                                    {value:'Soberanía alimentaria', label:'Soberanía alimentaria'},
                                ]}
                            />
                        </Grid>
                        {/* Resumen */}
                        <Grid item xs={12}> 
                            <Typography variant="subtitle1" sx={{ pt: 4, fontWeight: 900 }} >
                                Resumen
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography align="justify" paragraph sx={{ fontSize:'12px', pl:2, pr:2 }} >
                            El resumen deberá ser de 2000 caracteres y contar con el visto bueno del director(es) de tesis. El archivo a cargar en formato zip deberá contener: <strong>1 archivo de Excel con el resumen y 1 archivo PDF del resumen firmado por el director de tesis (5 MB máximo).</strong><br />
                            </Typography >
                            <Typography align="center" sx={{ fontSize:'12px' }} >
                            El formato del formulario se puede descargar en <a href="https://drive.google.com/drive/folders/1PsJIAMVRWv3TAdHXPL-zLcgfft8jkblH?usp=sharing" target="_blank" rel="noreferrer">este enlace</a>.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="resTitulo"
                                label="Título de trabajo"
                                name="resTitulo"
                                required
                                size="small"
                                value={resTitulo}
                                onChange={handleInputChange}
                                variant='standard'
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="resDirector"
                                label="Director de tesis"
                                name="resDirector"
                                required
                                size="small"
                                value={resDirector}
                                onChange={handleInputChange}
                                variant='standard'
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                type={"file"}
                                fullWidth
                                onChange={e => setFileState(e)}
                                helperText="Subir resumen *"
                                variant='standard'
                            />
                        </Grid>
                    </Grid>
                    </Paper>

                    {/* Boton */}
                    <Paper elevation={2}>
                    <Button
                        type="submit"
                        fullWidth
                        endIcon={<SendIcon />}
                    >
                        Enviar
                    </Button>
                    </Paper>

                    {/* Footer */}
                    <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                        <Grid item xs={12}>
                            <Divider />
                            <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                                <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                                Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                                La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                                <a href="http://www.cibnor.gob.mx/component/content/article/472" target="_blank" rel="noreferrer" >Política de privacidad</a>
                            </Typography >
                        </Grid>
                    </Grid>
                </Box>    
            </Box>

            {/* Dialogo de espera a la fecha de registro */}
            <Dialog
                open={isRegisterTime}
                disableEscapeKeyDown={true}
                >
                <DialogContent sx={{
                                margin: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                    <Typography variant='h4' align='center'>
                        El periodo de registro ha concluido, gracias por participar.
                    </Typography>
                    <Avatar
                    sx={{ width: '100%', height: '100%' }}
                        src="https://eventos.cibnor.mx/registro/en-linea/_logos/logo-xxii-semana-posgrado.png"
                        variant="square" 
                    />
                </DialogContent>
            </Dialog>
            {/* Dialogo de espera porque se esta enviando la informacion */}
            <Dialog 
                open={sendingForm}
                onClose={handleCloseWaitingDialog}
                disableEscapeKeyDown={true}
                >
                <DialogTitle id="alert-dialog-title" >
                    {"Enviando información..."}
                </DialogTitle>
                <DialogContent sx={{
                                margin: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            </Container>
        </ThemeProvider>
    )
}
